/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import PropTypes from "prop-types";
import { Typography as MuiTypography } from "@mui/material";

const TypographySize = [
  "hero, title1",
  "title2",
  "title3",
  "body",
  "small",
  "mini",
];
const TypographyDecoration = ["underline", "strikethrough"];
const TypographyTransform = ["lowercase", "uppercase", "capitalize"];
const TypographyComponent = ["div", "span", "p", "h3", "h4", "h5", "h6"];

const getComponent = (variant, component) => {
  if (variant === "hero") return "h4";
  if (variant === "title1") return "h5";
  if (variant === "title2" || variant === "title3") return "h6";
  return component;
};

function Typography({
  children,
  size,
  component,
  align,
  weight,
  noWrap,
  color,
  paragraph,
  caseing,
  decoration,
  variant,
  pointer,
  style,
  ...props
}) {
  return (
    <MuiTypography
      component={getComponent(variant, component)}
      variant={variant}
      align={align}
      size={size}
      noWrap={noWrap}
      elipsis
      color={color}
      paragraph={paragraph}
      fontWeight={weight}
      textTransform={caseing}
      style={{
        textDecoration: decoration,
        cursor: pointer ? "pointer" : "unset",
        ...style,
      }}
      title={children || ""}
      {...props}
    >
      {children}
    </MuiTypography>
  );
}

const propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.string.isRequired,
  component: PropTypes.oneOf(TypographyComponent),
  align: PropTypes.string.isRequired,
  weight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  noWrap: PropTypes.bool,
  paragraph: PropTypes.bool,
  caseing: PropTypes.oneOf(TypographyTransform),
  color: PropTypes.string,
  decoration: PropTypes.oneOf(TypographyDecoration),
  variant: PropTypes.oneOf(TypographySize).isRequired,
  pointer: PropTypes.bool,
  style: PropTypes.objectOf(),
};

const defaultProps = {
  weight: 400,
  noWrap: false,
  paragraph: false,
  color: "#5e5e5e",
  caseing: "initial",
  decoration: "initial",
  component: "span",
  pointer: false,
  style: {},
};

Typography.propTypes = propTypes;
Typography.defaultProps = defaultProps;

export default Typography;
